/* Vogadog : « Ajouter au panier » ouvre le panier en tiroir au lieu de la page panier */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function showError(form, message) {
    var box = form.querySelector('.vg-cart-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'vg-cart-error';
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message;
  }

  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    }
    var old = form.querySelector('.vg-cart-error');
    if (old) old.textContent = '';

    var data = new FormData(form);
    data.append('sections', 'cart-drawer,cart-icon-bubble');
    data.append('sections_url', window.location.pathname);

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showError(form, res.description || res.message || 'Impossible d’ajouter ce produit au panier.');
          return;
        }
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
        }
      });
  });
})();
